var _excluded = ["errors", "object", "onChange", "onSubmit"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import noop from 'lodash.noop';
import PropTypes from 'prop-types';
import React from 'react';
import Form from './Form';

class BoundForm extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onSubmit", e => {
      e.preventDefault();
      this.props.onSubmit(e, this.state.formData);
    });

    _defineProperty(this, "handleChange", name => data => {
      var value = data.target instanceof Element ? data.target.value : data;
      this.setState(prevState => {
        return {
          formData: _objectSpread(_objectSpread({}, prevState.formData), {}, {
            [name]: value
          })
        };
      });
      this.props.onChange(this.state.formData);
    });

    this.state = {
      formData: props.object
    };
  }

  getChildContext() {
    return {
      value: this.state.formData,
      errors: this.props.errors,
      onChange: this.handleChange
    };
  }

  render() {
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars -- This will take care of itself when converted to function component */
    var _this$props = this.props,
        errors = _this$props.errors,
        object = _this$props.object,
        onChange = _this$props.onChange,
        onSubmit = _this$props.onSubmit,
        props = _objectWithoutProperties(_this$props, _excluded);

    return /*#__PURE__*/React.createElement(Form, _extends({
      onSubmit: this.onSubmit
    }, props));
  }

}

_defineProperty(BoundForm, "propTypes", {
  errors: PropTypes.object,
  object: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  onChange: PropTypes.func
});

_defineProperty(BoundForm, "defaultProps", {
  errors: {},
  onSubmit: noop,
  onChange: noop
});

_defineProperty(BoundForm, "childContextTypes", {
  value: PropTypes.object,
  errors: PropTypes.object,
  onChange: PropTypes.func
});

BoundForm.displayName = "BoundForm";
export default BoundForm;